import { createContext } from 'react';
export var SiteChromeStaticContext = /*#__PURE__*/createContext(undefined);